import { render, staticRenderFns } from "./MenuInventario.vue?vue&type=template&id=b4257ac6&"
import script from "./MenuInventario.vue?vue&type=script&lang=js&"
export * from "./MenuInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports